<ng-template ixPageHeader>
  <ix-page-title-header>
    <ix-save-debug-button></ix-save-debug-button>
  </ix-page-title-header>
</ng-template>

<div class="cards">
  <ix-console-card></ix-console-card>
  <ix-syslog-card></ix-syslog-card>
  <ix-audit-card></ix-audit-card>
  <ix-kernel-card></ix-kernel-card>
  <ix-cron-card></ix-cron-card>
  <ix-init-shutdown-card></ix-init-shutdown-card>
  <ix-sysctl-card></ix-sysctl-card>
  <ix-storage-card></ix-storage-card>
  <ix-replication-settings-card></ix-replication-settings-card>
  <ix-access-card></ix-access-card>
  <ix-allowed-addresses-card></ix-allowed-addresses-card>
  <ix-self-encrypting-drive-card *ixHasRole="[Role.FullAdmin]"></ix-self-encrypting-drive-card>
  <ix-isolated-gpus-card></ix-isolated-gpus-card>
  <ix-global-two-factor-card></ix-global-two-factor-card>
  <ix-system-security-card *ngIf="!!(isSystemLicensed$ | async)"></ix-system-security-card>
</div>
